/* block */
(function(){
  var srObserved=false;
  function nativeBubble(){var cw=document.querySelector('chat-widget');return (cw&&cw.shadowRoot)?(cw.shadowRoot.querySelector('.lc_text-widget--bubble')||cw.shadowRoot.querySelector('button')):null;}
  function applyI18n(){
    var cw=document.querySelector('chat-widget');
    if(!cw) return;
    var want=JSON.stringify({chatViaSmsEmail:'Email Us',chatWithAnAgent:'Live Chat with Our Team',chatWithVoice:'Talk to Jenny (Voice)'});
    if(cw.getAttribute('i-1-8n-labels')!==want){cw.setAttribute('i-1-8n-labels',want);}
    if(cw.getAttribute('height')!=='520'){cw.setAttribute('height','520');}
  }
  /* Aria 2026-08-14: readable type scale for the GHL chat widget.
     The conversation UI (chat-message, chat-pane, chat-input) each render in their OWN nested
     shadow root, so page CSS cannot reach them. GHL ships the message bubble at 14px, system
     notices and the end-of-chat "start a new chat" block at 12px, and the timestamp at 11px —
     all at or under the readable floor on a phone. GHL delivers its CSS via adoptedStyleSheets,
     which Chrome applies AFTER any <style> element in the same shadow root, so an injected style
     tag loses every tie-break against their !important rules. We therefore append our own
     constructed sheet to adoptedStyleSheets (last wins) and also out-specify them by repeating
     the class, so the fix holds even if the sheet order ever changes. */
  var FW_CHAT_TYPE_CSS = [
    /* padding-bottom reserves a strip for the timestamp footer, which GHL absolutely
       positions at bottom:8px inside the bubble sized for 11px text — at 14px it
       overlaps the message text on short bubbles without this reserve */
    '.bubble.bubble.bubble{font-size:16px !important;line-height:1.5 !important;padding-bottom:34px !important;min-width:150px !important;}',
    ':host(.lc-chat-end-message.lc-chat-end-message) .bubble.bubble{padding-bottom:0 !important;min-width:120px !important;}',
    '.informational.informational.informational{font-size:14px !important;line-height:1.45 !important;}',
    ':host(.lc-chat-end-message.lc-chat-end-message) .informational.informational,',
    ':host(.lc-chat-end-message.lc-chat-end-message) ::slotted(*){font-size:14px !important;line-height:1.45 !important;}',
    '.footer-text.footer-text{font-size:14px !important;line-height:1.35 !important;}',
    '.message-image-info,.upload-text,.image-info,.vr-recording-label,.vr-status{font-size:14px !important;}',
    '.chat-selection-button.chat-selection-button{font-size:16px !important;}',
    '.lc_text-widget--agency-branding,.lc_text-widget--agency-branding-inner,.lc_text-widget--agency-branding a{font-size:14px !important;}',
    /* "Fetch older conversations" + any other pane action button: GHL builds them as
       <ion-button size="small"> (~13px) in whichever root hosts the pane */
    'ion-button.ion-button.ion-button{font-size:14px !important;}',
    /* "Click here" restart-chat button: <ion-button size="small"> ~13px with no tap padding */
    '.reset-chat-button.reset-chat-button{font-size:15px !important;font-weight:600;min-height:44px !important;display:inline-flex !important;align-items:center;align-self:flex-start;}',
    '.live-message-end-feedback.live-message-end-feedback{font-size:14px !important;line-height:1.45 !important;}'
  ].join('');
  var FW_CHAT_SHEET=null;
  function fwTypeScale(root){
    if(!root) return;
    if(root.host){
      try{
        if(!FW_CHAT_SHEET){ FW_CHAT_SHEET=new CSSStyleSheet(); FW_CHAT_SHEET.replaceSync(FW_CHAT_TYPE_CSS); }
        var cur=root.adoptedStyleSheets||[];
        if(cur.indexOf(FW_CHAT_SHEET)===-1){ root.adoptedStyleSheets=Array.prototype.slice.call(cur).concat(FW_CHAT_SHEET); }
      }catch(e){
        if(!root.getElementById('fw-chat-type')){
          var st=document.createElement('style'); st.id='fw-chat-type';
          st.textContent=FW_CHAT_TYPE_CSS; root.appendChild(st);
        }
      }
    }
    root.querySelectorAll('*').forEach(function(el){ if(el.shadowRoot) fwTypeScale(el.shadowRoot); });
  }
  function hideNative(){
    applyI18n();
    var cw=document.querySelector('chat-widget');
    if(!cw||!cw.shadowRoot) return;
    var sr=cw.shadowRoot;
    /* bubble: inline !important (GHL stylesheet beats injected CSS for the bubble) */
    var b=sr.querySelector('.lc_text-widget--bubble')||sr.querySelector('[class*="--bubble"]')||sr.querySelector('[class*="bubble"]');
    if(b&&b.style.getPropertyValue('display')!=='none'){ b.style.setProperty('display','none','important'); }
    /* prompt: CSS only - NEVER inline. GHL reuses the prompt node as the open chat box (class swap),
       so inline display:none would keep the opened chat invisible. */
    var bx=sr.querySelector('.lc_text-widget--box.active');
    if(bx&&bx.style.getPropertyValue('display')==='none'){ bx.style.removeProperty('display'); }
    if(!sr.getElementById('fw-hide-native')){
      var st=document.createElement('style');
      st.id='fw-hide-native';
      st.textContent='.lc_text-widget--prompt{display:none !important;}';
      sr.appendChild(st);
    }
    if(!srObserved){
      srObserved=true;
      new MutationObserver(hideNative).observe(sr,{childList:true,subtree:true});
    }
    /* native bubble now suppressed in this same pass — safe to reveal the host */
    cw.classList.add('fw-native-tamed');
    fwTypeScale(sr);
  }
  hideNative();
  /* Aria 2026-08-17 (audit): a document-wide MutationObserver plus a 1.5s interval used to run
     forever on every page, including pages that never load the chat widget. Both only exist to
     survive late/mobile hydration; once hideNative() has installed the widget-scoped shadow-root
     observer (srObserved), they are redundant, so stand them both down at that point. */
  var fwHideIv;
  function fwStandDown(){ if(!srObserved) return false; mo.disconnect(); clearInterval(fwHideIv); return true; }
  var mo=new MutationObserver(function(){ hideNative(); fwStandDown(); });
  mo.observe(document.documentElement,{childList:true,subtree:true});
  fwHideIv=setInterval(function(){ hideNative(); fwStandDown(); },1500);
  fwStandDown();
  document.addEventListener('click',function(e){
    var t=e.target.closest && e.target.closest('#fw-livechat-launcher');
    /* Aria 2026-08-14: the widget is now lazy-loaded, so on a first click it may not exist yet.
       Kick the loader and poll for the bubble instead of failing silently. */
    if(t){ e.preventDefault();
      var b=nativeBubble();
      if(b){ b.click(); return; }
      if(window.fwLoadGhlChat) window.fwLoadGhlChat();
      var tries=0, iv=setInterval(function(){
        var nb=nativeBubble();
        if(nb){ clearInterval(iv); nb.click(); }
        else if(++tries>60){ clearInterval(iv); }
      },100);
    }
  }, true);
})();
